export default __webpack_public_path__ + "static/media/logo-uefs.7f9ded70.png";